import { SendTenantUserInvitationRequestSchema, SendTenantUserInvitationResponseSchema } from './send-tenant-user-invitation.schema';
/**
 * Send Tenant User Invitation Endpoint Contract
 * Sends an invitation email to a tenant user (super-admin only)
 */ export const sendTenantUserInvitationContract = {
    method: 'POST',
    path: '/api/v2/tenants/:tenantId/users/:userId/send-invitation',
    description: 'Send an invitation email to a tenant user',
    requestSchema: SendTenantUserInvitationRequestSchema,
    responseSchema: SendTenantUserInvitationResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - user is not inactive',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'User or tenant not found',
            503: 'Service Unavailable - identity provider or mail delivery unreachable'
        }
    }
};

//# sourceMappingURL=send-tenant-user-invitation.contract.js.map